import emojiRegex from 'emoji-regex';

const regex = emojiRegex();

export function removeEmoji(text: string): string {
  return text.replace(regex, '');
}
